module.exports = __webpack_public_path__ + "static/media/loading3.d109bca5.png";